"use client";

import { useEffect } from "react";

interface BlogProxyProps {
  newSlug: string;
  originalPath: string;
}

export default function BlogProxy({ newSlug }: BlogProxyProps) {
  const newBlogUrl = `https://blog.searchright.net/${newSlug}`;

  useEffect(() => {
    // 새 블로그로 리다이렉션
    window.location.href = newBlogUrl;
  }, [newBlogUrl]);

  return (
    <div className="flex h-screen items-center justify-center bg-white">
      <div className="text-center">
        <div className="mb-4 text-lg text-gray-700">블로그 페이지로 이동 중입니다...</div>
        <div className="text-sm text-gray-500">
          자동으로 이동되지 않는다면{" "}
          <a href={newBlogUrl} className="text-blue-600 underline hover:text-blue-800">
            여기를 클릭
          </a>
          해주세요.
        </div>
      </div>
    </div>
  );
}
